import React from 'react'
import { connect } from 'react-redux'

import Hero from 'common/Hero'
import HeroTitle from 'common/Hero/title'
import HeroSubtitle from 'common/Hero/subtitle'

import PageContent from 'common/PageContent'
import Section from 'common/Section'
import SectionTitle from 'common/Section/title'
import SectionHeader from 'common/Section/header'
import DepartmentsTable from 'views/Departments/table'
import LifeAtStyleTheory from 'views/LifeAtStyleTheory'

import { resetTitle } from 'reducers/global'

const Testimony = props => (
  <div className={`flex-ns w-50-ns ${props.className}`}>
    <img src={props.image} className='br-100 st-mb3 w3 h3 st-mr3-l mr2-m' />
    <div>
      <p className='ma0 mb3 dark-gray norms-16'>{props.description}</p>
      <div className='norms-12'>
        <span className='b'>{props.name}</span> - <span className='silver'>{props.job}</span>
      </div>
    </div>
  </div>
)

const MeetOurTeam = props => (
  <div>
    <SectionHeader>Meet Our Team</SectionHeader>
    <div className='flex flex-wrap'>
      <Testimony className='st-mb4 pr4-l pr3-m'
        image='https://d2u7nrdrppwhsn.cloudfront.net/career/team_chris_2018-05.jpg'
        job='CEO & Co-Founder'
        description={`Chris co-founded Style Theory in Jan ‘16 and leads the company's strategy & product. He entered the startup world after working with Bain & Co, one of the top 3 strategy consulting firms globally.`}
        name='Chris'
      />
      <Testimony className='st-mb4 pl4-l pl3-m'
        image='https://d2u7nrdrppwhsn.cloudfront.net/career/team_raena_2018-05.jpg'
        job='COO & Co-Founder'
        description={`Raena worked in Kenya for a nonprofit before joining Goldman Sachs, one of the top investment banks. Yearning for impactful work, she left to build Style Theory - a smarter way to consume fashion.`}
        name='Raena'
      />
      <Testimony className='st-mb4 pr4-l pr3-m'
        image='https://d2u7nrdrppwhsn.cloudfront.net/career/team_hengky_2018-05.jpg'
        job='Head of Engineering'
        description={`Hengky is one of Style Theory's first engineers and the engine behind its pursuit of a world-class engineering team. He joined after a career in Ice House, one of Indonesia's best development house.`}
        name='Hengky'
      />
      <Testimony className='st-mb4 pl4-l pl3-m'
        image='https://d2u7nrdrppwhsn.cloudfront.net/career/team_jayme_1.jpg'
        job='Head Of Bags'
        description={`Combining ten years of corporate banking experience and a passion in building new businesses, Jayme launched South East Asia's first ever designer bag subscription in 2018 with thousands on the waitlist. She now manages more than a thousand designer bags, hundreds of individual consignors and leads a team with a sole focus on making a dream designer bag collection accessible to all.`}
        name='Jayme'
      />
      <Testimony className='st-mb4 mb0-ns pr4-l pr3-m'
        image='https://d2u7nrdrppwhsn.cloudfront.net/career/team_joshua_2018-05.jpg'
        job='Head of Marketing'
        description='After five years at Zalora where he led CRM, Joshua brought his unique mix of experiences to Style Theory where he now leads marketing. He believes in constant innovation, being purpose-driven, and always doing better for the customer.'
        name='Joshua'
      />
      <Testimony className='st-mb4 pl4-l pl3-m'
        image='https://d2u7nrdrppwhsn.cloudfront.net/career/team_brandon_2018-05.jpg'
        job='Head of CX'
        description='Brandon leads the CX team at Style Theory with a simple philosophy: Doing what is right for the customers. He is passionate about delighting customers by constantly improving product and processes. Brandon joined Style Theory from Google, where he was a core member of the Global Customer Experience team.'
        name='Brandon'
      />
    </div>
  </div>
)

const WhoWeAreSection = props => (
  <Section>
    <SectionTitle>Welcome</SectionTitle>
    <div className='flex justify-center st-mb4'>
      <div className='st-pr3 dn db-ns flex-1'>
        <img src='https://d2u7nrdrppwhsn.cloudfront.net/career/whoweare_2018-05_b1.jpg' />
      </div>
      <div style={{ flex: '1.911' }}>
        <img src='https://d2u7nrdrppwhsn.cloudfront.net/career/sg-halloween-2018.jpg' />
      </div>
    </div>
    <div className='flex-ns st-mb4'>
      <div className='st-mb4 mb0-ns'>
        <SectionHeader marginSmall>We are a team of fearless problem-solvers who believe that the future is ours to craft</SectionHeader>
        <p className='dark-gray norms-16'>
          We are building the future way of living that is more sustainable, forward and in all honesty - so much smarter. Reinventing a large and inefficient $225B Fashion industry takes not just intelligence and passion but also courage to tread where no one has been. Like Uber, Netflix & Airbnb, we harness the power of technology and the internet to bridge the traditional limitations in logistics and product-care, creating a sharing economy for fashion consumption.
        </p>
        <p className='dark-gray norms-16'>
          Clothing being as fundamental as food means behavioural patterns have been deeply ingrained and trying to change people's behaviour will not be an easy task. However, we know that building a brighter future is always difficult. It involves solving problems many deem impossible and displaying relentless courage to take the route less taken. It requires dedication, commitment and a lot of teamwork.
        </p>
        <p className='dark-gray norms-16'>That is why at Style Theory, we are building an exceptional team who is passionate about bringing that future into reality. By working with us, we will grow together and shape that future that can truly make a difference.</p>
      </div>
      <div className='flex-none flex flex-column justify-center w-third-ns st-ml4-ns'>
        <blockquote className='serif norms-24 norms-36-l mh0 mt0 st-mb3'>
        “The future doesn't just happen, someone has to make it happen”
        </blockquote>
      </div>
    </div>
    <div className='flex flex-wrap flex-nowrap-ns mb5 pb4'>
      <div className='flex-auto st-pr3-ns pr1 mb1 w-50 w-auto-ns'>
        <img src='https://d2u7nrdrppwhsn.cloudfront.net/career/whoweare_2018-05_b4.jpg' />
      </div>
      <div className='flex-auto st-pr3-ns pl1 mb1 w-50 w-auto-ns'>
        <img src='https://d2u7nrdrppwhsn.cloudfront.net/career/whoweare_2018-05_b2.jpg' />
      </div>
      <div className='flex-auto st-pr3-ns pr1 w-50 w-auto-ns'>
        <img src='https://d2u7nrdrppwhsn.cloudfront.net/career/life_2018-05_b2.jpg' />
      </div>
      <div className='flex-auto w-50 w-auto-ns pl1'>
        <img style={{ maxHeight: '442px' }} src='https://d2u7nrdrppwhsn.cloudfront.net/career/life_2018-05_b4.jpg' />
      </div>
    </div>
    <MeetOurTeam />
  </Section>
)

class WhoWeAre extends React.Component {
  constructor (props) {
    super(props)
    props.dispatch(resetTitle())
  }

  render () {
    return (
      <div>
        <Hero background='https://d2u7nrdrppwhsn.cloudfront.net/career/hero_2018-05.jpg'>
          <HeroTitle>
            Join Our Team
          </HeroTitle>
          <HeroSubtitle>
            We're on a mission to build a smarter, more sustainable way to consume fashion
          </HeroSubtitle>
        </Hero>
        <PageContent>
          <WhoWeAreSection />
          <Section>
            <SectionTitle>Open Positions</SectionTitle>
            <DepartmentsTable />
          </Section>
          <LifeAtStyleTheory />
        </PageContent>
      </div>
    )
  }
}

export default connect()(WhoWeAre)
